export type MatriculaStatus =
  | 'PENDENTE'
  | 'ATIVA'
  | 'TRANCADA'
  | 'CANCELADA'
  | 'CONCLUIDA'
  | 'TRANSFERIDA';

export const MATRICULA_TERMINAL_STATUS: ReadonlyArray<MatriculaStatus> = [
  'CANCELADA',
  'CONCLUIDA',
  'TRANSFERIDA',
];

const TRANSITIONS: Record<MatriculaStatus, ReadonlyArray<MatriculaStatus>> = {
  PENDENTE: ['ATIVA', 'CANCELADA'],
  ATIVA: ['TRANCADA', 'CANCELADA', 'CONCLUIDA'],
  TRANCADA: ['ATIVA', 'CANCELADA'],
  CANCELADA: [],
  CONCLUIDA: [],
  TRANSFERIDA: [],
};

export function canTransitionMatricula(
  from: MatriculaStatus,
  to: MatriculaStatus,
): boolean {
  return TRANSITIONS[from].includes(to);
}

export function nextMatriculaStatuses(
  from: MatriculaStatus,
): ReadonlyArray<MatriculaStatus> {
  return TRANSITIONS[from];
}

export interface Matricula {
  id: string;
  tenantId: string;
  alunoId: string;
  courseId: string;
  curriculumId: string;
  courseName?: string | null;
  cohortId: string | null;
  poloId: string | null;
  numeroMatricula: string;
  status: MatriculaStatus;
  dataInicio: string | null;
  dataFimPrevista: string | null;
  dataConclusao: string | null;
  motivoCancelamento: string | null;
  createdAt: string;
  updatedAt: string;
}
